import { SxProps, Theme } from '@mui/material';
import { brandAlpha } from '../../../theme/mixins';

/**
 * Drawn in the outline the requested cards in the grid wear, so the strip and the cards read
 * as the same kind of thing: hours pencilled in, waiting for an answer.
 */
export const pendingBoxStyles: SxProps<Theme> = {
    mb: 2,
    p: { xs: 1.5, sm: 2 },
    borderRadius: 2,
    border: '1px dashed',
    borderColor: brandAlpha('primary', 0.45),
    backgroundColor: brandAlpha('primary', 0.03),
};

/** In the bell, where the panel around it is frame enough. */
export const pendingEmbeddedBoxStyles: SxProps<Theme> = {
    pb: 1,
};

export const pendingTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
};

export const pendingSubtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.875rem',
    mb: 1,
};

export const pendingRowStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 1,
    py: 1,
    borderTop: '1px solid',
    borderColor: 'divider',
};

export const pendingWhenStyles: SxProps<Theme> = {
    fontWeight: 600,
};

export const pendingDetailStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.875rem',
};

export const pendingRespondByStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.75rem',
};

export const pendingActionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 1,
    flexShrink: 0,
};

export const pendingShowMoreStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    pt: 1,
};
